export default __webpack_public_path__ + "static/media/almonds.42342401.jpg";